/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AdditionalOptions from './AdditionalOptions/index'
import AppointmentData from './AppointmentData/index'
import CloseAction from './CloseAction/index'
import LoadingState from './LoadingState/index'
import NextAppointment from './NextAppointment/index'
import Patient from './Patient/index'
import PatientInfo from './PatientInfo/index'
import PatientOptions from './PatientOptions/index'
import PatientSelect from './PatientSelect/index'
import React from 'react'
import ScheduleOptions from './ScheduleOptions/index'
import SimilarPatients from './SimilarPatients/index'
import SubmitAction from './SubmitAction/index'
import TypeAndDuration from './TypeAndDuration/index'
import TysiaOverlay from 'DesignSystem/TysiaOverlay/index'
import TysiaOverlayContent from 'DesignSystem/TysiaOverlay/TysiaOverlayContent/index'
import TysiaOverlayFooter from 'DesignSystem/TysiaOverlay/TysiaOverlayFooter/index'
import TysiaOverlayHeader from 'DesignSystem/TysiaOverlay/TysiaOverlayHeader/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<AppointmentData
  viewPath={`${viewPath}/AppointmentData`}
/>
<TysiaOverlay
  viewPath={`${viewPath}/TysiaOverlay`}
 top={50}
 bottom="unset"
 width={isMedia.mobile ? "720px" : "auto"}
 minWidth={isMedia.mobile ? "auto" : "760px"}
 justifyContent="flex-start"
>
{childProps => (
<React.Fragment>
<LoadingState
{...childProps}
  viewPath={`${viewPath}/LoadingState`}
/>
<TysiaOverlayHeader
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayHeader`}
 paddingLeft={dtSpaceLs}
 paddingRight={dtSpaceLs}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 height={52}
>
{childProps => (
<React.Fragment>
<div
  data-testid="New.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-l16': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<PatientSelect
  viewPath={`${viewPath}/PatientSelect`}
/>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
<PatientInfo
  viewPath={`${viewPath}/PatientInfo`}
/>
</div>
<div
  data-testid="New.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<NextAppointment
  viewPath={`${viewPath}/NextAppointment`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
</React.Fragment>
)}
</TysiaOverlayHeader>
<TysiaOverlayContent
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayContent`}
 flexGrow={0}
 flexShrink={1}
 flexBasis="auto"
 overflowY="visible"
 height={52}
>
{childProps => (
<React.Fragment>
<PatientOptions
{...childProps}
  viewPath={`${viewPath}/PatientOptions`}
/>
<SimilarPatients
{...childProps}
  viewPath={`${viewPath}/SimilarPatients`}
/>
</React.Fragment>
)}
</TysiaOverlayContent>
<TysiaOverlayFooter
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayFooter`}
 paddingLeft={dtSpaceLs}
 paddingRight={dtSpaceLs}
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 alignItems="center"
 height={52}
>
{childProps => (
<React.Fragment>
<div
  data-testid="New.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<TypeAndDuration
  viewPath={`${viewPath}/TypeAndDuration`}
/>
<ScheduleOptions
  viewPath={`${viewPath}/ScheduleOptions`}
/>
</div>
<div
  data-testid="New.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-1-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-3-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal3}`}
>
<AdditionalOptions
  viewPath={`${viewPath}/AdditionalOptions`}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</div>
</React.Fragment>
)}
</TysiaOverlayFooter>
</React.Fragment>
)}
</TysiaOverlay>
{children}
</React.Fragment>)
}